<template>
  <div class="quiz-options row quiz-fillblank">
    <div class="col-md-12">
      <div class="sentence-fill border-0" :class="changeColor">
        <h1 dir="auto" class="text-primarydark fw-bold nanosans pt-3 mb-3" :class="changeColor">
          <span v-for="(part, index) in processedQuestion" :key="index">
            <!-- If it's a placeholder, replace it with the selected word -->
            <template v-if="part.isPlaceholder">
              <span class="">
                {{ part.text || "__" }}
              </span>
            </template>
            <!-- Otherwise, render the static text -->
            <template v-else>
              {{ part.text }}
            </template>
          </span>
        </h1>
      </div>
    </div>
    <ul class="choos-trans check-sentence">
      <li v-for="(word, i) in quizwords" :key="i">
        <div class="box-shaper">
          <input type="checkbox" :id="word.option + i" :name="word.option + i" v-model="sentenceMatch"
            :value="word.option" :checked="processedQuestion.some(part => part.text === word.option)"
            @change="selectWord(i, word.option, word.audio_file)" :disabled="processedQuestion.filter(part => part.isPlaceholder && part.text !== '').length >= maxBlanks && !processedQuestion.some(part => part.text === word.option) || !cisAllMatched" />
          <label :for="word.option + i" :disabled="!cisAllMatched">
            {{ word.option }}
          </label>
        </div>
      </li>
    </ul>
  </div>
  <div class="row mt-5" v-if="isAnsChecked">
    <div class="col-md-12 col-12 text-center">
      <!-- {{ processedQuestion }} -->
      <!-- {{ selectedWords }} -->
      <button type="button"
        @click="checkAnswers(wordvalue.id, wordvalue.correct_sentence_question, wordvalue.correct_sentence_question_audio_file)"
        class="btn btn-main btn-lg py-3 w-100" :disabled="!this.notdis && !isAllMatched">
        تحقق
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["quizwords", "wordvalue", "isAnsChecked"],
  data() {
    return {
      sentenceMatch: [],
      changeColor: "",
      notdis: false,
      cisAllMatched: true,
      correcAnswers: [],
      showAfterDelay: false,
      selectedWords: '', // Ensure this is an array
      processedQuestion: [],
      currentAudios: null,
      maxBlanks: 0,
    };
  },
  emits: ["correct-check", "notdis", "checBtn"],
  watch: {
    wordvalue: {
      immediate: true,
      handler(newVal) {
        if (newVal?.question) {
          this.processQuestion(newVal.question); // Process the question
        }
      },
    },
    'wordvalue.id': function (newId, oldId) {
      if (newId !== oldId) {
        this.resetQuestionState();
      }
    },
  },
  methods: {
    resetQuestionState() {
      this.selectedWords = ''; // Reset selected word
      this.sentenceMatch = []; // Reset matched sentence
      this.changeColor = ''; // Reset color class
      this.notdis = false; // Disable the button initially
      this.cisAllMatched = true; // Reset matching state
      this.processedQuestion = []; // Clear processed question
      this.maxBlanks = 0; // Reset max blanks
      if (this.wordvalue?.question) {
        this.processQuestion(this.wordvalue.question); // Re-process the question for the new ID
      }
    },

    processQuestion(question) {
      const parts = question.split("__"); // Split question by "__"
      this.processedQuestion = parts.reduce((acc, part, index) => {
        // console.log('ye lo', acc);
        acc.push({ text: part, isPlaceholder: false }); // Add static text
        if (index < parts.length - 1) {
          acc.push({ text: "", isPlaceholder: true }); // Add placeholder
        }
        return acc;
      }, []);
      this.maxBlanks = this.processedQuestion.filter(part => part.isPlaceholder).length;
    },

    selectWord(index, word, voice) {
      // Check if the word is already selected
      const existingIndex = this.processedQuestion.findIndex(part => part.text === word);

      if (existingIndex !== -1) {
        // If the word is already placed, remove it
        this.processedQuestion[existingIndex].text = "";
      } else {
        // Otherwise, place it in the next available placeholder
        const placeholderIndex = this.processedQuestion.findIndex(part => part.isPlaceholder && !part.text);
        const filledBlanks = this.processedQuestion.filter(part => part.isPlaceholder && part.text).length;

        if (placeholderIndex !== -1) {
          this.processedQuestion[placeholderIndex].text = word;
        }
        if (filledBlanks >= this.maxBlanks) {
          return; // Stop the user from selecting more words
        }
      }

      // Build the selected sentence, removing extra spaces
      this.selectedWords = this.processedQuestion
        .map(part => (part.isPlaceholder && !part.text ? "__" : part.text.trim())) // Trim each part
        .filter(part => part !== "") // Filter out empty strings
        .join(" ") // Join with a single space
        .replace(/\s([?.!,])/g, "$1"); // Remove spaces before punctuation marks

      // Audio playback
      if (this.currentAudios) {
        this.currentAudios.pause();
        this.currentAudios.currentTime = 0;
      }
      if (voice) {
        this.currentAudios = new Audio(voice);
        this.currentAudios.play();
      }

      // Enable button only if all blanks are filled
      this.notdis = this.processedQuestion.every(part => !part.isPlaceholder || part.text !== "");
    },

    checkAnswers(questionId, correctAnswer, sound) {
      this.$emit('checBtn', false);
      this.$emit('notdis', true);
      const sentence = this.selectedWords.toLowerCase();
      const correctSentence = correctAnswer.toLowerCase();

      // console.log("User's Answer:", sentence);
      // console.log("Correct Answer:", correctSentence);


      this.cisAllMatched = false;

      if (sentence === correctSentence) {

        setTimeout(() => {
          this.changeColor = "text-success";
        }, 100);

        this.$emit("correct-check", 1, questionId);
        // console.log(sound);

        if (sound) {
          const audio = new Audio(sound);

          setTimeout(() => {
            audio.play();
          }, 100);

        }

      } else {
        this.changeColor = "text-danger";
        this.$emit("correct-check", 0, questionId);
      }
    },
  },
};
</script>
